const React = require("react");
const {augmentHOCWrapper} = require("../util/HOCUtil");
const VaultContext = require("../top/VaultContext").default;

module.exports = augmentHOCWrapper(function(Component) {
	class VaultDispatchWrapper extends React.Component {
		static displayName =
			"VaultDispatch:" + (Component.displayName ?? Component.name);
		static contextType = VaultContext;

		dispatch = action => {
			if (!this.context) {
				return;
			}

			this.context.dispatch({
				...action,
				dispatchedBy: Component.displayName,
			});
		};

		render() {
			return <Component {...this.props} dispatch={this.dispatch} />;
		}
	}

	return VaultDispatchWrapper;
});
